.entry-content {
    padding: 0 8px;
}

/* Padding for email engagement/reaction bar needs to be reduced */
.entry-content > :last-child {
    padding-bottom: 16px;
}
